import { CompleteCondition, EditableCondition } from 'modules/queryBuilder/types';
import { applyConditionTransformations } from './applyConditionTransformations';
import { transformInBetweenDates } from './transformInBetweenDates';

/**
 * Applies requirement-level transformations to a single requirement
 * Works with both EditableRequirement and EditableRequirement types
 */
export const applyRequirementTransformations = <T extends Record<string, unknown>>(
  requirement: T,
): T => {
  // First apply condition-level transformations to each condition
  const { searchCombo: pretypedSearchCombo = {} } = requirement;
  const searchCombo = pretypedSearchCombo as Record<string, unknown>;
  const requirementWithConditionTransformations = {
    ...requirement,
    searchCombo: {
      ...searchCombo,
      searchQueries: (
        (searchCombo?.searchQueries || []) as CompleteCondition[] | EditableCondition[]
      ).map((condition) => applyConditionTransformations(condition)),
    },
  };
  // Then apply requirement-level transformations (like transformInBetweenDates)
  return transformInBetweenDates(requirementWithConditionTransformations);
};
